import { Link } from 'react-router-dom';

const products = [
  {
    title: 'Standard Stretch Tents',
    image: '/assets/img/2774bcfc1052.webp',
    description: 'Our high-performance stretch tents offer unmatched versatility and style. Available in 8 sizes for weddings, corporate events, and festivals.',
    features: ['Waterproof fabric', 'UV resistant', 'Fire rated', 'Easy setup'],
    link: '/products/standard-stretch-tents',
  },
  {
    title: 'Custom Stretch Tents',
    image: '/assets/img/bb8781b5799f.webp',
    description: 'Built to your exact specifications in any size, shape, and colour. We engineer bespoke solutions from scratch to match your vision.',
    features: ['Made to measure', 'Custom colours', 'Unique shapes', 'Bespoke configurations'],
    link: '/products/custom-stretch-tents',
  },
  {
    title: 'Custom Printed Skins',
    image: '/assets/img/0f5fb24fd382.webp',
    description: 'Transform your brand into a statement with a fully custom-printed skin. High-resolution full-colour printing delivers maximum visual impact.',
    features: ['Full-colour print', 'Brand customisation', 'High-res graphics', 'Dye-sublimation'],
    link: '/products/custom-printed-skins',
  },
  {
    title: 'Bespoke Decor',
    image: '/assets/img/f3fb71045e63.webp',
    description: 'Elevate your event beyond the structure with our bespoke decor services. We craft immersive environments tailored to your theme.',
    features: ['Fabric draping', 'Ambient lighting', 'Fairy lights', 'Themed styling'],
    link: '/products/bespoke-decor',
  },
];

export default function ProductsGrid() {
  return (
    <section className="py-20 bg-gradient-to-br from-teal-500 to-teal-600">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-white mb-3">
            Explore the Range
          </h2>
          <p className="text-white/80 text-base max-w-xl mx-auto">
            Every product in our lineup is crafted to the highest standard. Click any card to learn more.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((product, index) => (
            <div
              key={index}
              className="group bg-white/10 backdrop-blur-sm rounded-2xl overflow-hidden hover:bg-white/20 hover:-translate-y-1 transition-all duration-300"
            >
              {/* Image with overlaid title */}
              <div className="relative h-60 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="text-xl font-bold text-white leading-snug">
                    {product.title}
                  </h3>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col gap-4">
                <p className="text-sm text-white/85 leading-relaxed">
                  {product.description}
                </p>

                {/* Feature tags */}
                <div className="flex flex-wrap gap-1.5">
                  {product.features.map((feature, idx) => (
                    <span
                      key={idx}
                      className="px-2.5 py-1 bg-white/20 text-white text-xs font-medium rounded-full"
                    >
                      {feature}
                    </span>
                  ))}
                </div>

                {/* CTA */}
                <Link
                  to={product.link}
                  className="inline-flex items-center gap-1.5 text-white hover:text-white/80 font-semibold text-sm mt-auto group/btn whitespace-nowrap"
                >
                  <span>View Details</span>
                  <i className="ri-arrow-right-line text-base group-hover/btn:translate-x-1 transition-transform"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
